import { InvestorBidState, InvestorBidStatus, ProjectStatus } from '~/constants';
import { Project, ProjectBidSummary } from '~/types/project';
import { getInvestorBidAmount, getNetProceeds, getFeeAmount, getOtherBudgetItemsAmount } from './projectBidDataFns';

interface InvestorBidData {
  investorBidAmount: string
  investorBidAmountUnit?: string
}

interface NetProceedsData {
  netProceeds: string
  netProceedsUnit?: string
}

export default function projectBidData(project: Project, projectCosts: any): any[] {
  if (project.acceptedBid) {

    //const { bid, projectStatus, childProjectId, investor } = project.acceptedBid;
    const bid = project.acceptedBid;
    const childProjectId = project.acceptedBid.id;

    const metadata = {
      investorId: project.acceptedBid.investorId,
      projectId: childProjectId,
      parentProjectId: bid?.parentProjectId
    };

    const investorBidData = getInvestorBidAmount(project, bid, projectCosts) || {};
    const { investorBidAmount, investorBidAmountUnit } = investorBidData as InvestorBidData;
    const feeToSeller = getFeeAmount(project, bid, projectCosts) || {};
    const otherBudgetItemsData = getOtherBudgetItemsAmount(bid, projectCosts) || {};
    const { otherBudgetItems, hasOtherBudgetItems } = otherBudgetItemsData;
    const netProceedsData = getNetProceeds(project, bid, projectCosts) || {};
    const { netProceeds, netProceedsUnit } = netProceedsData as NetProceedsData;

    // Default
    return [{
      investorBidAmount,
      investorBidAmountUnit,
      feeToSeller,
      otherBudgetItems,
      netProceeds,
      netProceedsUnit,
      pendingBid: true,
      hasOtherBudgetItems,
      bidState: 'ACCEPTED',
      ...metadata
    }];

  } else {

    return project?.bidSummary?.map((row: ProjectBidSummary) => {
      const { bid, projectStatus, childProjectId, investor } = row;
      const metadata = {
        investorId: investor?.id,
        projectId: childProjectId,
        parentProjectId: bid?.parentProjectId
      };

      const investorBidData = getInvestorBidAmount(project, bid, projectCosts) || {};
      const { investorBidAmount, investorBidAmountUnit } = investorBidData as InvestorBidData;
      const feeToSeller = getFeeAmount(project, bid, projectCosts) || {};
      const otherBudgetItemsData = getOtherBudgetItemsAmount(bid, projectCosts) || {};
      const { otherBudgetItems, hasOtherBudgetItems } = otherBudgetItemsData;
      const netProceedsData = getNetProceeds(project, bid, projectCosts) || {};
      const { netProceeds, netProceedsUnit } = netProceedsData as NetProceedsData;

      if (projectStatus === ProjectStatus.DECLINED_TO_BID && project?.portfolioId) {
        return {
          bidState: InvestorBidState.DECLINED_TO_BID,
          ...metadata
        };
      }

      if (project?.portfolioId &&
        (projectStatus === ProjectStatus.BID_REJECTED ||
          bid?.bidStatus === InvestorBidStatus.DECLINED ||
          bid?.bidStatus === InvestorBidStatus.REJECTED)) {
        return {
          bidState: InvestorBidState.CONVERSATION_ENDED,
        };
      }

      if (bid === undefined || bid?.bidStatus === InvestorBidStatus.INVITED) {
        return {
          netProceeds,
          bidState: InvestorBidState.AWAITING_BID,
          ...metadata
        };
      }

      if (bid?.bidStatus === InvestorBidStatus.PENDING) {
        return {
          investorBidAmount,
          investorBidAmountUnit,
          feeToSeller,
          otherBudgetItems,
          netProceeds,
          netProceedsUnit,
          ...metadata,
          pendingBid: true,
          hasOtherBudgetItems,
          calculatedIrr: bid.calculatedIrr,
          manualIrr: bid.manualIrr
        };
      }

      //? Is this used? 
      if (bid?.bidStatus === InvestorBidStatus.ACCEPTED) {
        return {
          color: 'var(--color-primary)',
          investorBidAmount: <>{getInvestorBidAmount(project, bid, projectCosts)}<br />BID ACCEPTED</>,
          ...metadata
        };
      }

      // Default
      return {
        investorBidAmount,
        bidState: InvestorBidState.AWAITING_BID,
        ...metadata
      };
    });
  }
}